import {
  SET_SELECTED_SECTION,
  SET_SHOW_MISLABEL_RANGE,
  SET_SHOW_DUPLICATE_RANGE,
} from "./constants";
import { MetadataSectionTypes } from "types";

const INITIAL_STATE: MetadataState = {
  selectedSection: null,
  showMislabelsRange: false,
  showDuplicatesRange: false,
};

const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_SELECTED_SECTION:
      return { ...state, selectedSection: action.data };

    case SET_SHOW_MISLABEL_RANGE:
      return { ...state, showMislabelsRange: action.data };

    case SET_SHOW_DUPLICATE_RANGE:
      return { ...state, showDuplicatesRange: action.data };

    default:
      return state;
  }
};

export default reducer;

interface MetadataState {
  selectedSection: MetadataSectionTypes;
  showDuplicatesRange: boolean;
  showMislabelsRange: boolean;
}
